// extracted by mini-css-extract-plugin
export var columnWrapperOneColumnLayout = "student-profile-module--columnWrapperOneColumnLayout--c834f";
export var excerpt = "student-profile-module--excerpt--64808";
export var externalUrls = "student-profile-module--externalUrls--a484b";
export var gridItemFocus = "student-profile-module--gridItemFocus--d38cc";
export var leadMediaThumb = "student-profile-module--leadMediaThumb--fb762";
export var linkButton = "student-profile-module--linkButton--d5f5a buttons--button--38c11 buttons--darkButton--26ce7";
export var rightColumnOneColumnLayout = "student-profile-module--rightColumnOneColumnLayout--aa7f4";
export var sectionTitle = "student-profile-module--sectionTitle--30761";
export var studentNavigation = "student-profile-module--studentNavigation--13ab7";
export var studentNavigationLink = "student-profile-module--studentNavigationLink--cf5f1";
export var title = "student-profile-module--title--30a65";